module.exports = __webpack_public_path__ + "media/images/lp/industries/realestate/gigbase_structure-9c5ba779b0a40f92a85a4fd125f688a2.png";